import Alert from '@nib-components/alert';
import Link from '@nib-components/link';
import { MedicareCardType, RCHACountries } from '@nib/phi-constants';
import { PHONE_NUMBERS } from '@nib/validation';
import { Field } from 'formik';
import { default as React } from 'react';
import styled from 'styled-components';
import { Country, MedicareRadioGroup, ResidencyStatusRadio } from '../..';
import { getGroupEventHandlerProps } from '../../util/propTypes';
import { AddFunnelPropFromContext } from '../funnel-context';
import NestedFormFields from '../nested-form-fields';
const NoLineBreak = styled.span`
  white-space: nowrap;
`;
const PartnerResidencyStatusGroup = props => {
  const {
    id = 'partnerResidencyStatus',
    name = 'partnerResidencyStatus',
    groupOnBlurHandlers,
    groupOnChangeHandlers,
    hasPartnerResidencyMismatch,
    values,
    funnel,
    residencyStatusHelpText
  } = props;
  const {
    [`${name}--medicareCardType`]: medicareCardType,
    [`${name}--citizenshipCountry`]: citizenshipCountry
  } = values;
  const showResidencyStatusRadio = medicareCardType == MedicareCardType.Yellow;
  const showCountryField = medicareCardType == MedicareCardType.None;
  const showNoCardResidencyStatusRadio = medicareCardType == MedicareCardType.None && RCHACountries.includes(citizenshipCountry);
  const eventHandlers = {
    groupOnBlurHandlers,
    groupOnChangeHandlers
  };
  return React.createElement("div", null, React.createElement(Field, {
    name: `${name}--medicareCardType`,
    id: `${id}--medicareCardType`,
    label: "What is the type of your partner's Medicare card?",
    help: "",
    component: MedicareRadioGroup,
    ...getGroupEventHandlerProps({
      ...eventHandlers,
      id: 'medicareCardType'
    })
  }), React.createElement(NestedFormFields, {
    expanded: showResidencyStatusRadio || showCountryField || hasPartnerResidencyMismatch,
    showLeftBorder: false
  }, showResidencyStatusRadio && React.createElement(Field, {
    name: `${name}--residencyStatus`,
    id: `${id}--residencyStatus`,
    label: "Choose your partner's type of cover?",
    component: ResidencyStatusRadio,
    help: residencyStatusHelpText,
    ...getGroupEventHandlerProps({
      ...eventHandlers,
      id: 'residencyStatus'
    })
  }), showCountryField && React.createElement(Field, {
    label: "Country of residency",
    name: `${name}--citizenshipCountry`,
    id: `${id}--citizenshipCountry`,
    component: Country,
    ...getGroupEventHandlerProps({
      ...eventHandlers,
      id: 'citizenshipCountry'
    })
  }), showNoCardResidencyStatusRadio && React.createElement(Field, {
    name: `${name}--noCardResidencyStatus`,
    id: `${id}--noCardResidencyStatus`,
    label: "Choose your partner's type of cover?",
    component: ResidencyStatusRadio,
    help: residencyStatusHelpText,
    ...getGroupEventHandlerProps({
      ...eventHandlers,
      id: 'noCardResidencyStatus'
    })
  }), hasPartnerResidencyMismatch && React.createElement(Alert, {
    id: "nib-online-terms",
    background: "light",
    type: "warning",
    variation: "soft"
  }, "We are unable to continue your application online as your partner has a different residency status to you.", React.createElement("br", null), "To apply, please call\u00A0", React.createElement(NoLineBreak, null, React.createElement(Link, {
    href: `tel:${PHONE_NUMBERS[funnel]}`
  }, PHONE_NUMBERS[funnel])))));
};
const PartnerResidencyStatusWithFunnel = props => React.createElement(AddFunnelPropFromContext, null, React.createElement(PartnerResidencyStatusGroup, {
  ...props
}));
export default PartnerResidencyStatusWithFunnel;